/**
 * 圆形玻璃图标按钮。
 *
 * iOS 的导航栏按钮就是这种形态：圆形、半透明、只有一个图标。
 * 尺寸固定 36px（触控热区用额外的 padding 撑到 44px，符合最小点击尺寸建议）。
 */

import type { Icon as PhosphorIcon } from '@phosphor-icons/react';

import { IconGlyph } from './IconGlyph';
import { Pressable } from './Pressable';

export interface IconButtonProps {
	glyph: PhosphorIcon;
	label: string;
	onClick: () => void;
	/** filled 用于"已激活"语义，例如已收藏 */
	variant?: 'glass' | 'plain' | 'filled';
	size?: number;
	disabled?: boolean;
	className?: string;
}

export function IconButton({
	glyph,
	label,
	onClick,
	variant = 'glass',
	size = 18,
	disabled = false,
	className = '',
}: IconButtonProps): JSX.Element {
	const surface = {
		glass: 'glass shadow-e1 text-label',
		plain: 'text-label-2',
		filled: 'bg-cta text-on-cta',
	}[variant];

	return (
		<Pressable
			aria-label={label}
			disabled={disabled}
			onClick={onClick}
			className={`inline-flex h-9 w-9 shrink-0 items-center justify-center rounded-full ${surface} ${className}`}
		>
			<IconGlyph glyph={glyph} size={size} />
		</Pressable>
	);
}
